module.exports = __webpack_public_path__ + "static/media/1-1.3b981710.mp3";